import type { ColummListColumn } from "app/pages/sales-intelligence/common-components/search-results-table/types";
import { renderDefaultTextCell } from "app/pages/sales-intelligence/common-components/table-cells/factories";
import type {
    CrmRecordsColumn,
    CrmRecordsRow,
} from "app/pages/sales-intelligence/domain/crm-integration/types/records";

import { renderCrmDateCell, renderCrmRecordCell } from "./render-utils";
import type { CrmRecordsColumnAdapter, ICrmRecordsColumnAdapters } from "./types";

const buildBaseColumn = (column: CrmRecordsColumn): ColummListColumn<CrmRecordsRow> => ({
    key: column.id,
    dataIndex: column.id,
    title: column.title,
    sorter: true,
    ellipsis: true,
});

/**
 * Adapters the CRM-records module exposes for its (fully dynamic) records table. Each adapter turns a
 * backend-described `CrmRecordsColumn` into a column config; the data type selects the cell renderer.
 */
export const crmRecordsColumnAdapters = {
    createTextColumnAdapter: (): CrmRecordsColumnAdapter => (column) => ({
        ...buildBaseColumn(column),
        render: renderDefaultTextCell,
    }),

    createDateColumnAdapter: (): CrmRecordsColumnAdapter => (column) => ({
        ...buildBaseColumn(column),
        render: renderCrmDateCell,
    }),

    createRecordColumnAdapter: (): CrmRecordsColumnAdapter => (column) => ({
        ...buildBaseColumn(column),
        render: renderCrmRecordCell,
    }),
} satisfies ICrmRecordsColumnAdapters;
